var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Module', [_c('div', {
    directives: [{
      name: "report",
      rawName: "v-report.module",
      value: {},
      expression: "{}",
      modifiers: {
        "module": true
      }
    }],
    staticClass: "nav",
    attrs: {
      "AEGIS-FIRST-SCREEN-TIMING": ""
    }
  }, _vm._l(_vm.showList, function (item, index) {
    return _c('fixed-item', {
      key: index,
      attrs: {
        "data": item
      }
    });
  }), 1), _vm.currentSetting && _vm.currentSetting.开启广告位 ? _c('EggAd') : _vm.isMounted && _vm.setting && _vm.setting.开启广告位 ? _c('EggAd') : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };